import { useTranslation } from "react-i18next";

import { Button, Card, Col, Divider, Flex, Row, Space, Spin } from "antd";
import { Info } from "components/elements";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { formatBankAccountNo } from "utils/formatter/formatCommon";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import styles from "../styles/EmployeeForm.module.css";
import EmployeeEmploymentForm from "./EmployeeEmploymentForm";
function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

// function formatBankAccountNo(bankAccountNo) {
//   const length = bankAccountNo.length;

//   if (length === 10) {
//     return `${bankAccountNo.slice(0, 3)}-${bankAccountNo.slice(3, 6)}-${"x".repeat(4)}`;
//   } else if (length > 10) {
//     return `${bankAccountNo.slice(0, 3)}-${bankAccountNo.slice(3, 6)}-${"x".repeat(length - 6)}`;
//   }

//   return bankAccountNo;
// }

function EmployeeEmploymentInfoComponent({
  isLoading = false,
  isMovement = {},
  isModalOpen = false,
  onSubmitModal = () => { },
  isEditing = false,
  initialValues = {},
  currentEmployment = {},
  onEdit = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  setMovement = () => { },
  setModalOpen = () => { },
  handleCancel = () => { },
  handleOpen = () => { },
  handleClose = () => { },
  isProbation = {},
  isModal = {},
  oldDetails = [],
  newDetails = [],
  employeeTypeOptions = [],
  employeeStatusTypeOptions = [],
  employeeOptions = [],
  employmentTypeOptions = [],
  departmentOptions = [],
  positionOptions = [],
  shiftOptions = [],
  branchOptions = [],
  // workInLocationOptions = [],
  holidayCalendarOptions = [],
  currentWorking = {},
  bankOptions = [],
  movementGroupOptions = [],
  reasonForSeparationOptions = [],
  view = false,
  isVisible = false,
  handleToggleVisibility = () => { },
  pageForm = "EMPLOYEE",
  permissions
}) {

  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  // const language = i18n.language == "en" ? "En" : ""
  const reasonForSeparation = reasonForSeparationOptions.filter((option) => option?.value === initialValues?.reasonOfSeparation) || null
  // console.log("initialValues", );
  const checkDisableVisible = () => {
    if (pageForm === "EMPLOYEE") {
      return roles?.includes("ACCESS_DATA_SECURITY|EMPLOYEE|EMPLOYMENT_INFO") ? false : true
    } else {
      return permissions?.VISIBLE ? false : true
    }
  }


  if (isEditing) {
    return (
      <EmployeeEmploymentForm
        oldDetails={oldDetails}
        newDetails={newDetails}
        movementGroupOptions={movementGroupOptions}
        isMovement={isMovement}
        isModalOpen={isModalOpen}
        onSubmitModal={onSubmitModal}
        initialValues={initialValues}
        currentWorking={currentWorking}
        onSubmit={onSubmit}
        onCancel={onCancel}
        setMovement={setMovement}
        setModalOpen={setModalOpen}
        handleCancel={handleCancel}
        handleOpen={handleOpen}
        handleClose={handleClose}
        isProbation={isProbation}
        isModal={isModal}
        employeeTypeOptions={employeeTypeOptions}
        employeeStatusTypeOptions={employeeStatusTypeOptions}
        employeeOptions={employeeOptions}
        employmentTypeOptions={employmentTypeOptions}
        departmentOptions={departmentOptions}
        positionOptions={positionOptions}
        shiftOptions={shiftOptions}
        isLoading={isLoading}
        workInLocationOptions={branchOptions}
        holidayCalendarOptions={holidayCalendarOptions}
        bankOptions={bankOptions}
        reasonForSeparationOptions={reasonForSeparationOptions}
      />
    )
  }

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Spin spinning={isLoading}>
        <Card style={{ border: "solid 1px #EAECF0" }}>

          <Space style={{ width: "100%" }} direction="vertical" >
            {(roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|EMPLOYMENT_INFO") ||
              (view === false && roles.includes("UPDATE_EMPLOYEE|EMPLOYMENT|EMPLOYMENT_INFO"))) && (
                <Row justify="end" style={{ gap: "10px" }}>
                  {roles.includes("ACCESS_DATA_SECURITY|EMPLOYEE|EMPLOYMENT_INFO") &&
                    <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                      icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                      onClick={handleToggleVisibility}
                    // disabled={checkDisableVisible()}
                    />
                  }
                  {
                    view === false && roles.includes("UPDATE_EMPLOYEE|EMPLOYMENT|EMPLOYMENT_INFO") &&
                    <Button onClick={onEdit} disabled={isLoading} type="primary"
                      style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                    >
                      <Flex align="center" justify="center" gap={8}>
                        <EditIcon />
                        {t("common.edit").toUpperCase()}
                      </Flex>
                    </Button>
                  }
                </Row>)}
            <Flex vertical style={{ rowGap: "16px" }}>
              <span style={{ fontSize: "16px" }}>{t('employment-information.header')}</span>

              <Row gutter={[0, 16]}>
                <Col span={12}>
                  <Info label={t('employment-information.label.employee-status')} value={i18n.language === "en" ? initialValues.employeeStatus?.nameEn || "-" : initialValues.employeeStatus?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.employee-type')} value={i18n.language === "en" ? initialValues.employeeType?.nameEn || "-" : initialValues.employeeType?.name || "-"} />
                </Col>
                {initialValues.employeeStatus?.code === 'EMPLOYEE_STATUS_TYPE_03' ? <><Col span={12}>
                  <Info label={t('employment-information.label.date-of-expriation')} value={initialValues?.dateExpiration ? formatDate({ dateString: initialValues?.dateExpiration, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                  <Col>
                    <Info label={t('master_data.label.reason_for_separationimport')} value={initialValues?.reasonOfSeparation ? (i18n.language === "en" ? reasonForSeparation[0]?.nameEn : reasonForSeparation[0]?.name) : '-'} />
                  </Col></> : null}
                <Col span={12}>
                  <Info label={t('employee.label.employment-date')} value={initialValues?.employmentDate ? formatDate({ dateString: initialValues?.employmentDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.probation_date')} value={initialValues?.probationDate ? formatDate({ dateString: initialValues?.probationDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.dateEffective')} value={initialValues?.dateEffective ? formatDate({ dateString: initialValues?.dateEffective, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.date-contract-expire')} value={initialValues?.dateContractExpire ? formatDate({ dateString: initialValues?.dateContractExpire, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                <Col span={12}>
                  <Info
                    label={t('employment-information.label.report-to')}
                    value={
                      initialValues.supervisor && initialValues.supervisor.length > 0
                        ? initialValues.supervisor
                          .map((supervisor) =>
                            i18n.language === "en"
                              ? `${supervisor.nameEn} ${supervisor.surNameEn}`
                              : `${supervisor.name} ${supervisor.surName}`
                          )
                        : "-"
                    }
                  />
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.holiday-calendar')} value={i18n.language === "en" ? initialValues?.holidayCalendar?.nameEn || "-" : initialValues?.holidayCalendar?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.driver-no')} value={initialValues?.driverNo || "-"} />
                </Col>
                <Col span={12}>
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.driver-no-expire')} value={initialValues?.driverExpire ? formatDate({ dateString: initialValues?.driverExpire, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : "-"} />
                </Col>
                {/* <Col span={12}>
                <Info label={t('employment-information.label.manpower-type')} value={initialValues.manpowerType ? (initialValues.manpowerType === "NEW" ? t('employment-information.label.manpower.type.new') : t('employment-information.label.manpower.type.replace')) : "-"} />
              </Col> */}
                <Col span={12}>
                  <Info label={t('employment-information.label.record-time')} value={initialValues?.recordTime ? (initialValues?.recordTime === "RECORD" ? t('Record') : t('dont-record')) : "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employment-information.label.ot_request')}
                    value={initialValues?.otRequestUnable === "Y" ? t('allow') : t('not-allowed')}
                  />
                </Col>
              </Row>
            </Flex>
            <Divider className={styles.customDivider} />
            <Flex vertical style={{ rowGap: "16px" }}>
              <span style={{ fontSize: "16px" }}>{t('corporate-information')}</span>
              <Row gutter={[0, 16]}>
                <Col span={12}>
                  <Info label={t("company_profile.label.company_name")} value={i18n.language === "en" ? initialValues?.company?.nameEn || "-" : initialValues?.company?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.employee_no')} value={initialValues?.employeeNo || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.department')} value={i18n.language === "en" ? initialValues?.department?.nameEn || "-" : initialValues?.department?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.position')} value={i18n.language === "en" ? initialValues?.position?.nameEn || "-" : initialValues?.position?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.branch')}
                    value={i18n.language === "en" ? initialValues?.branch?.nameEn : initialValues?.branch?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('employee.label.shift')} value={i18n.language === "en" ? initialValues?.shift?.nameEn || "-" : initialValues?.shift?.name || "-"} />
                </Col>
              </Row>
            </Flex>

            <Divider className={styles.customDivider} />
            {view === true &&
              <Row justify="end" style={{ gap: "10px" }}>
                <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                  icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                  onClick={handleToggleVisibility}
                  disabled={checkDisableVisible()}
                />
              </Row>}
            <Flex vertical style={{ rowGap: "16px" }}>
              <span style={{ fontSize: "16px" }}>{t('payment-information.header')}</span>
              <Row gutter={[0, 16]}>
                <Col span={12}>
                  <Info label={t('employment-information.label.employment-type')} value={i18n.language === "en" ? initialValues?.employmentType?.nameEn || "-" : initialValues?.employmentType?.name || "-"} />
                </Col>
                <Col span={12}>
                  <Info label={t('payment-information.label.payment-method')} value={initialValues?.paymentMethod ? (initialValues?.paymentMethod === 'CASH' ? t('employee.salary.label.cash') : initialValues?.paymentMethod === 'PROMPTPAY' ? t('employee.salary.label.PromptPay') : t('employee.salary.label.bank')) : "-"} />
                </Col>

                {/* <Col span={12}>

                <Flex>
                
                  <Info label={t('employee.salary.label.bank')} value={i18n.language === "en" ? initialValues.bankAccount?.nameEn || "-" : initialValues.bankAccount?.name || "-"} />


                </Flex
              </Col> */}
                {initialValues.paymentMethod === 'BANK' ?
                  <><Col span={12}>
                    <Flex vertical={true} style={{ gap: "12px" }}>
                      <span style={{ fontSize: "16px", color: "#667085" }}>{t('employee.salary.label.bank')}</span>
                      <Flex>
                        {initialValues?.bankAccount?.icon && (
                          <img
                            src={initialValues?.bankAccount?.icon}
                            alt="Bank icon"
                            style={{ width: "30px", marginRight: "8px" }} />
                        )}
                        {/* <img
      src={initialValues?.bankAccount?.icon}
      alt="Bank icon"
      style={{ width: "30px", marginRight: "8px" }}
    /> */}
                        <span style={{ alignContent: "center", fontSize: "16px" }}>
                          {i18n.language === "en" ? initialValues?.bankAccount?.nameEn || "-" : initialValues?.bankAccount?.name || "-"}
                        </span>
                      </Flex>
                    </Flex>
                  </Col>
                    <Col span={12}>
                      <Info
                        label={t('employee.salary.label.bank_account_no')}
                        value={
                          initialValues?.bankAccountNo
                            ? formatBankAccountNo(initialValues?.bankAccountNo, isVisible)
                            : "-"
                        }
                      />
                    </Col></> : null
                }
                {initialValues.paymentMethod === 'PROMPTPAY' ?
                  <>
                    <Col span={12}>
                      <Info
                        label={t('employee.salary.label.promptpayNo')}
                        value={
                          initialValues?.promptpayNo
                        }
                      />
                    </Col></> : null
                }
              </Row>
            </Flex>
          </Space>
        </Card>
      </Spin>
    </Space>
  )
}

export default EmployeeEmploymentInfoComponent
